module.exports = __webpack_public_path__ + "img/Fares-old.9ab04c48.jpg";